module.exports = __webpack_public_path__ + "static/media/garvinpic2.82779cb6.gif";